<template>
  <div :class="checkClass">
    <div class="spinner"></div>
    <p>Loading...</p>
  </div>
</template>
<script>
export default {
  name: 'Loader',
  props: ['field'],
  computed: {
    checkClass() {
      if (this.field === 'companies') {
        return 'loader-companies';
      }
      if (this.field === 'job-list') {
        return 'loader-job-list';
      }
      return 'loader';
    },
  },
};
</script>
<style>
.loader {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
}

.loader-companies {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 50vh;
}

.loader-job-list {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 200px;
}

.spinner {
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

p {
  margin-top: 10px;
}
</style>
